import { Dispatch } from 'react';
import { setWarningAction } from '../draftState/actions/setWarningAction';
import { DraftAction } from '../draftState/types';

export const warnOnMinimumScale = (
  targetScale: number,
  validScale: number,
  dispatch: Dispatch<DraftAction>
) => {
  if (targetScale < validScale) {
    dispatch(setWarningAction('MinimumScale', 'minimumScale.hint'));
  }
};
